



















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IEmailViewModel, AttachmentModel } from '@/models/fixedops/partsales';
import { IDialogOption } from '@/models/dialog';
import { Base } from '../common/base';
import { VHeaders, VAction, PaginationModel } from '@/models/pagedlistmodel';
import { attachmentService, partSalesService } from '@/shared';

@Component({
  components: {
    AppDialog: () => import('../common/app.dialog.vue'),
    Grid: () => import('../common/app.grid.vue'),
  },
  watch: {
    isDialogOpen(newVal) {
      this.emailDialog.model = newVal;
      if (newVal) {
        this.loadAttachment();
      }
    },
  },
  props: ['model', 'isDialogOpen'],
})
export default class PartSaleEmailSendComponent extends Base {
  public model: IEmailViewModel;
  public invoiceNumber: string;
  public froms: any = [];
  public emailModel: IEmailViewModel = {
    isEmail1: true,
    isEmail2: false,
  };
  public loading: boolean = false;
  public attachments: AttachmentModel[] = [];
  public emailDialog: IDialogOption = {
    width: 800,
    title: 'Send Email',
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: 'Send',
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.sendEmail();
    },
    onClose: (): void => {
      this.close();
    },
  };

  public paginations = new PaginationModel('name');
  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: false,
      text: '',
      value: 'selected',
      fieldType: 'checkbox',
      header: {
        type: 'checkbox',
      },
      onChange: (item) => {
        this.addAttachment(item);
      },
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'partSalesDetailSendEmail.sendMailGrid.attachmentType'
      ) as string,
      value: 'attachmentTypeName',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'partSalesDetailSendEmail.sendMailGrid.user'
      ) as string,
      value: 'userName',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'partSalesDetailSendEmail.sendMailGrid.comment'
      ) as string,
      value: 'comment',
    },
    {
      align: 'left',
      sortable: false,
      text: this.$parent.$t(
        'partSalesDetailSendEmail.sendMailGrid.uploadedAt'
      ) as string,
      value: 'createdDateTime',
      fieldType: 'date',
      format: 'MMMM Do YYYY h:mm A',
    },

    {
      align: 'center',
      text: this.$parent.$t(
        'partSalesDetailSendEmail.sendMailGrid.actions'
      ) as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
  public actions: VAction[] = [
    {
      type: 'button',
      icon: 'fas fa-eye',
      title: this.$parent.$t(
        'partSalesDetailSendEmail.sendMailGrid.gridActions.viewAttachment'
      ) as string,
      action: (model, action: VAction) => {
        this.viewAttachment(model.id, action);
      },
    },
  ];

  public mounted(): void {
    // mounted
  }

  public async sendEmail(): Promise<void> {
    if (!this.emailModel.fromEmail) {
      this.showAlert(
        false,
        this.$t('partSalesDetailSendEmail.alertPleaseFromEmail')
      );
      return;
    }
    if (this.model.signature) {
      this.emailModel.signature = this.model.signature;
    }

    if (
      this.emailModel.attachmentIdArray &&
      this.emailModel.attachmentIdArray.length
    ) {
      this.emailModel.checkedArray = this.emailModel.attachmentIdArray.join(
        ','
      );
    }

    try {
      this.emailDialog.loading = true;
      await partSalesService.sendEmail(this.emailModel);
      this.showAlert(
        true,
        this.$t('partSalesDetailSendEmail.alertEmailSentSuccessfully')
      );
    } finally {
      this.emailDialog.loading = false;
      this.close();
    }
  }

  public async getAttachments(): Promise<void> {
    try {
      this.loading = true;
      const response = await partSalesService.getAttachmentsAsync(
        this.model.invoiceNumber
      );
      this.attachments = response.results.filter((r) => {
        return (
          r.attachmentTypeName !== 'Text' &&
          r.attachmentTypeName !== 'Voice Recording' &&
          r.attachmentTypeName !== 'Voice Transcription'
        );
      });
      this.paginations.totalItems = this.attachments.length;
    } finally {
      this.loading = false;
    }
  }

  public close(): void {
    this.$emit('onClose');
  }

  public updatePaging(paging: PaginationModel): void {
    this.paginations = paging;
  }

  public addAttachment(attachment: AttachmentModel): boolean {
    if (!this.emailModel.attachmentIdArray) {
      this.emailModel.attachmentIdArray = [];
    }
    if (attachment.selected) {
      this.emailModel.attachmentIdArray.push(attachment.id);
    } else {
      const index = this.emailModel.attachmentIdArray.indexOf(attachment.id);
      if (index > -1) {
        this.emailModel.attachmentIdArray.splice(index, 1);
      }
    }
    return true;
  }

  public async viewAttachment(
    attachmentId: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
    }
  }

  public loadAttachment() {
    this.froms.push(this.userEmail);
    this.emailModel.subject = `${this.model.storeName} - ${this.$t(
      'partSalesDetailSendEmail.invoiceNumber'
    )} ${this.model.invoiceNumber}`;
    this.emailModel.customerEmail1 = this.model.customerEmail1;
    this.emailModel.customerEmail2 = this.model.customerEmail2;
    this.emailModel.invoiceNumber = this.model.invoiceNumber;
    if (this.model.buttonType) {
      this.emailModel.buttonType = this.model.buttonType;
    } else if (this.emailModel.buttonType == 'submit') {
      // this.emailModel.buttonType == 'submit'
    } else {
      this.emailModel.buttonType = 'email';
    }
    this.getAttachments();
  }
}
